import React, { useEffect, useMemo, useRef } from "react";
import { NavLink } from "react-router-dom";


const MojCasinoHorizontalProvideri = (props) => {
    const { brands: brandsDict, showSmall, showAll, text, desc, from } = props;

    const containerRef = useRef(null);
    const pagesObserverRef = useRef(null);
    const imagesLoadedRef = useRef(false);

    const randomizeWithPriority = (dict, priorityCount = 9) => {
        // Convert dictionary → array of [id, data]
        const entries = Object.entries(dict);

        // Sort by SortOrder so we know which are the first N
        const sorted = entries.sort((a, b) => a[1].sortOrder - b[1].sortOrder);

        // Split into priority group and the rest
        const priorityGroup = sorted.slice(0, priorityCount);

        const restGroup = sorted.slice(priorityCount);

        // Diff random number every day
        const randomNumbers = casino.utils.generateTodayRandomNumber(entries.length);

        // Shuffle helper (stable, unbiased)
        const shuffle = (arr) =>
            arr
                .map((item) => ({ item, sort: randomNumbers }))
                .sort((a, b) => a.sort - b.sort)
                .map(({ item }) => item);

        // Shuffle each group separately
        const randomizedPriority = shuffle(priorityGroup);
        const randomizedRest = shuffle(restGroup);

        // Merge back together
        const finalArray = [...randomizedPriority, ...randomizedRest];

        // Convert entries → objects with id
        return finalArray.map(([id, data]) => ({ id, ...data }));
    }

    const getFilteredBrands = (list) => {
        //NullCheck liste, HizmanB
        if (!list || !Array.isArray(list)) return [];
        // Filtriranje SuperCasino providera van iz objekta, HizmanB
        return list.filter(item => item && item.nameNormalizirano && item.nameNormalizirano !== 'supercasino');
    };

    const brands = useMemo(() => {
        if (!brandsDict) return [];

        const randomizedList = randomizeWithPriority(brandsDict, 9);
        //Zvanje filtera, HizmanB
        return getFilteredBrands(randomizedList);
    }, [brandsDict]);

    const checkBrandNameZaLink = (brand) => {
        if (!brand) return "";
        let brandNormalized = brand.nameNormalizirano.toLowerCase();
        if (brand.jeMaliProvider) brandNormalized = "ostali-provideri";
        return brandNormalized;
    };

    const buildLogoUrl = (brand, isDark) =>
        `${casino.config.gameImagesUrl}${brand.nameNormalizirano}/logos/logo${isDark ? "-dark" : ""
        }.png?c=${casino.config.guiCacheVerzija}`;

    const renderBrandLogoLink = (brand, isDark) => {
        if (!brand) return null;

        const imgSrc = buildLogoUrl(brand, isDark);

        return (
            <NavLink
                to={`/provideri?provider=${checkBrandNameZaLink(brand)}`}
                onClick={() => window.scrollTo(0, 0)}
                className="game-item-small relative "
            >
                <div className="relative provider-brand-bg">
                    <img
                        data-src={imgSrc}
                        alt={brand.name + " logo"}
                        className="lazy provider-logo"
                    />
                </div>
            </NavLink>
        );
    };

    const renderBrand = (brand, brand2, brand3, i) => {
        const isDark = casino.utils.getCasinoTheme() === "dark";
        const step = 2;

        return (
            <div
                key={(brand?.nameNormalizirano || "empty") + i}
                className={
                    "margin-bottom-small game-item game-rows" +
                    (!showSmall ? "" : " game-item3") +
                    (brand ? " brandid-" + brand.id : "")
                }
                data-index={i / step}
            >
                {renderBrandLogoLink(brand, isDark)}
                {renderBrandLogoLink(brand2, isDark)}
                {renderBrandLogoLink(brand3, isDark)}

                {!brand2 && i > 0 && step > 1 && (
                    <a className="game-item-small relative">
                        <div className="relative">
                            <div className="provider-logo"> </div>
                        </div>
                    </a>
                )}
            </div>
        );
    };

    const renderBrandsGrid = () => {
        const gui = [];
        for (let i = 0; i < brands.length; i += 3) {
            gui.push(
                renderBrand(
                    brands[i],
                    brands[i + 1] || null,
                    brands[i + 2] || null,
                    i
                )
            );
        }
        return gui;
    };
   
    useEffect(() => {
        if (!brands.length) return;
        if (!containerRef.current) return;

        if (!imagesLoadedRef.current) {
            // Mount lazy load once
            casino.utils.lazyImages.mountEventLazyLoadImages();
            imagesLoadedRef.current = true;
        }

        const images = Array.from(
            containerRef.current.querySelectorAll("div.game-item2")
        );

        if (pagesObserverRef.current) {
            pagesObserverRef.current.disconnect();
        }

        if ("IntersectionObserver" in window && images.length) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    const lazyImage = entry.target;
                    const index = +lazyImage.dataset.index;
                    // original code for pages indicators was commented out, so kept as-is
                    // if (entry.isIntersecting) {
                    //   pages[index].classList.add("active");
                    // } else {
                    //   pages[index].classList.remove("active");
                    // }
                });
            });

            images.forEach((img) => observer.observe(img));
            pagesObserverRef.current = observer;

            return () => {
                observer.disconnect();
            };
        }
    }, [brands]);

    const brandsGui = useMemo(() => renderBrandsGrid(), [brands]);
    return (
        <div className="moj-casino-line" id={from}>
            <h2 className="homepage-margin2">
                {!showAll && <>{text}</>}
                {showAll && (
                    <NavLink className="component-title" to="/provideri">
                        {text}
                    </NavLink>
                )}
            </h2>

            {desc && <div className="desc homepage-margin2">{desc}</div>}

            <div className="horizontal-items v3">
                <div
                    className="horizontal-items--container clearfix mojcasino-padding v3"
                    ref={containerRef}
                >
                    {brandsGui}
                </div>
                <div className="horizontal-items--navigation no-buttons">
                    {/* sluzi za skrivanje scroolbarsa */}
                </div>
            </div>
        </div>
    );
};

export default MojCasinoHorizontalProvideri;
